<template>
    <v-main>
        <div id="section-to-print">
        <v-flex xs12 md6 v-model="showPrint">
          <v-textarea
            name="input-7-1"
            value="printTitle"
            v-model="printTitle"
            hint="">
          </v-textarea>
        </v-flex>
       <div v-if="selectedRegistration === null" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
       <div v-else>
        <v-flex xs12 md6 class="ml-4">
        <v-card flat class="mb-6" v-if="(selectedRegistration != null)">
          <v-layout row wrap>
            <v-flex>
              <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                <v-flex d-flex xs8 class="font-weight-bold" >{{selectedRegistration.VehicleNo}} - {{selectedRegistration.VehicleLicensePlateNo}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.ArticleNo}} - {{selectedRegistration.ArticleName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.CarrierNo}} - {{selectedRegistration.CarrierName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(selectedRegistration)}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.AgreementNo}} - {{selectedRegistration.AgreementName}}</v-flex>
              </v-layout>
                 <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                 <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.DeliveryNo}} - {{selectedRegistration.DeliveryName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.RequisitionNo1}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.RequisitionNo2}}</v-flex>
              </v-layout>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.ScanXRegNo}}</v-flex>
              </v-layout>
                <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                  <v-flex d-flex xs4>{{$t("1. weight")}}:</v-flex>
                  <v-flex d-flex xs8>{{getGrossWeightStr(selectedRegistration)}}</v-flex>
                </v-layout>
                <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                  <v-flex d-flex xs4>{{$t("2. weight")}}:</v-flex>
                  <v-flex d-flex xs8>{{get2WeightStr(selectedRegistration)}}</v-flex>
                </v-layout>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("WeightNet")}}:</v-flex>
                <v-flex d-flex xs8>{{getNetWeightStr(selectedRegistration)}}</v-flex>
              </v-layout>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Date")}}:</v-flex>
                <v-flex d-flex xs8>{{getDate(selectedRegistration.DateFirst)}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.PlantNo}} - {{selectedRegistration.PlantName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Producer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Producer")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.ProducerNo}} - {{selectedRegistration.ProducerName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.Facility}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.Comment1}}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
        <v-flex>
          <v-data-table id="table-to-print" hide-default-footer dense
            :headers="translatedHeaders()"
            :items="selectedRegistrations"
                    :items-per-page="1"
                    class="elevation-1">
                    <!-- <template v-slot:body="{ items }">
                      <tbody>
                          <tr v-for="header in headers">
                          <td>
                              {{ header.text }}
                          </td>
                          <td v-for="item in items">
                              {{ item[header.value] }}
                          </td>
                      </tr>
                      </tbody>
                    </template> -->
                    <template v-slot:[`item.DateFirst`]="{ item }">
                        <v-flex class="font-weight-bold">
                          {{ getDate(item.DateFirst) }}
                        </v-flex>
                      </template>
                  </v-data-table>
        </v-flex>
      </v-flex>
          <!-- <v-btn class="mr-1 mb-1" @click="close()" color="primary">
                      {{$t("Close")}}
                    </v-btn>
          <v-btn class="mr-1 mb-1" @click="printRegistration()" color="primary">
                      {{$t("Print")}}
                    </v-btn> -->
    </div>
  </div>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Reports from '@/modules/reports/reports'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as Security from '@/core/security'
import * as DateUtil from '@/core/date'
import { loadFacilities } from '@/core/archive'

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'print-registration-confirmation',
    loading: true,
    printTitle: '',
    selectedRegistration: null,
    selectedRegistrations: [],
    redirectTo: 'reports-registrations',
    hiddenFields: [],
    showPrint: true,
    results: [],
    useFacilityDescription: false,
    headers: [
      /* { text: 'VehicleNo', value: 'VehicleNo' }/* ,
      { text: 'ArticleNo', value: 'ArticleNo' },
      { text: 'CarrierNo', value: 'CarrierNo' },
      { text: 'CustomerNo', value: 'CustomerNo' },
      { text: 'AgreementNo', value: 'AgreementNo' },
      { text: 'DeliveryNo', value: 'DeliveryNo' },
      { text: 'RequisitionNo1', value: 'RequisitionNo1' },
      { text: 'RequisitionNo2', value: 'RequisitionNo2' },
      { text: 'ScanXRegNo', value: 'ScanXRegNo' },
      { text: 'WeightFirst', value: 'WeightFirst' },
      { text: 'WeightSecond', value: 'WeightSecond' },
      { text: 'WeightNet', value: 'WeightNet' },
      { text: 'DateFirst', value: 'DateFirst' },
      { text: 'PlantNo', value: 'PlantNo' },
      { text: 'Facility', value: 'Facility' },
      { text: 'Comment1', value: 'Comment1' } */
    ],
    id: null
  }),
  computed: {
  },
  methods: {
    printRegistrationBlock () {
      window.onafterprint = () => {
        this.close()
      }

      window.print()
    },
    printRegistration () {
      window.print()
    },
    close () {
      this.$router.push({ name: this.redirectTo })
    },
    printRegistrationBtn () {
      window.print()
      this.$router.push({ name: this.redirectTo })
    },
    isHide (fieldName) {
      return false // this.hiddenFields.some(h => h === fieldName )
    },
    translatedHeaders () {
      return this.headers.map(header => {
        const h = { ...header }
        h.text = this.$t(header.text)
        return h
      })
    },
    getCustomerStr (smReg) {
      if (smReg.CustomerNo && smReg.CustomerName) { return smReg.CustomerNo + ' - ' + smReg.CustomerName } else if (smReg.CustomerNo) { return smReg.CustomerNo } else if (smReg.CustomerName) { return smReg.CustomerName } else { return '' }
    },
    getGrossWeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.WeightFirst) + ' kg'
    },
    get2WeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.WeightSecond) + ' kg'
    },
    getNetWeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.WeightNet) + ' kg'
    },
    getDate (date) {
      return DateUtil.getDateTime(date)
    }
  },
  async mounted () {
    const regId = this.$route.params.id
    if (this.$route.params.header === undefined) {
      // Go back to Registrations
      this.$router.push({ name: this.redirectTo })
    }
    if (this.$route.params.header !== undefined) {
      this.printTitle = this.$route.params.header
    }
    if (Security.user.corporationDetails) {
      // const defaultHidden = '' // 'RequisitionNo2,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = '' // (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    if (regId) {
      const res = await Reports.loadRegistration(regId)
      if (!res.failed) {
        this.id = regId
        this.selectedRegistration = res.data
        this.selectedRegistrations[0] = this.selectedRegistration
        if (this.useFacilityDescription) {
          const facilities = await loadFacilities(0)
          // facilities.filter(e => e !== this.selectedRegistratio.No)
          const faDes = facilities.data.find(e => e.No === this.selectedRegistration.Facility)?.Description ?? ''
          this.selectedRegistration.Facility = faDes
        }
        // console.log('pip6', this.selectedRegistration, this.selectedRegistrations)
      }
    }
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
    this.$nextTick(() => {
      this.loading = false
      this.printRegistrationBlock()
    })
  }
}

</script>

  <style>
  @media print {
    .show-on-print {
      display: block !important;
    }
    body * {
      visibility: hidden;
    }
    #section-to-print, #section-to-print * {
      visibility: visible;
    }
    #section-to-print {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
    #table-to-print {
      position: absolute;
      left: 0;
      top: auto;
    }
    .v-main {
      padding: 0 !important;
    }
    .v-data-table td {
      font: 16px;
    }
    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }
  }
  </style>
